// The vocabulary moved to dietaryAttributes.ts - it is not DiningRD-only any more, since Data
// Kit items carry the same keys. This module stays as the DRD-facing alias so every existing
// import keeps working. Timber normalizes DRD's actual allergen/tag strings to these keys on
// import (see normalizeDrdAttribute in AsideDiningRD).
import { DIETARY_ATTRIBUTES, DietaryAttribute } from "./dietaryAttributes";

export type DrdAttribute = DietaryAttribute;
export const DRD_ATTRIBUTES: DrdAttribute[] = DIETARY_ATTRIBUTES;
